import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import shallowequal from "shallowequal";
import { MyIcon } from "../../common/baseConfig";
const fontSize = 16;
const padding = 35;
const lineW = 16;
const baseWidth = 1200;
export default class Tabs extends Component {
  state = {
    activeKey: 0,
    showLeft: false,
    showRight: false,
    pageCount: 0,
    lastWidth: 0,
    cur: 0,
  };
  static propTypes = {
    tabs: PropTypes.array.isRequired,
    onTabsChange: PropTypes.func,
    cancelMatchRouter: PropTypes.bool.isRequired
  };
  componentDidMount() {
    const { tabs } = this.props;
    if (this.isView()) {
      this.setState({
        showRight: true,
      })
    }
    //根据路由匹配跳转
    let activeKey = 0;
    let pathname = this.props.history.location.pathname;

    let DisciplineID = parseInt(pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length), 10);

    if (this.props.specialTabs === "select") {
      let pathArr = pathname.split("/");
      DisciplineID = parseInt(pathArr[2], 10);
    }
    if (this.props.cancelMatchRouter) {
      tabs.forEach((item, i) => {
        if (item.ID === DisciplineID) activeKey = i;
      });
    }
    if (this.props.cancelMatchRouter) {
      this.onTabChange(activeKey, DisciplineID, false);
    } else {
      this.onTabChange(activeKey, 0, false);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (!shallowequal(this.props.changeIndex, nextProps.changeIndex)) {
      this.onTabChange(nextProps.changeIndex, 0, false);
    }
  }
  onTabChange(activeKey, ID, isClick) {
    //isclick判断是否是用户点击事件
    let links = ReactDOM.findDOMNode(this.refs.links);
    let link = ReactDOM.findDOMNode(this.refs[`link${activeKey}`]);
    let linkWidth = link.getBoundingClientRect().width;
    let transLateW = 0;
    let line = ReactDOM.findDOMNode(this.refs.line);
    if (isClick) {
      transLateW = link.getBoundingClientRect().left - links.getBoundingClientRect().left + linkWidth / 2 - lineW / 2;

    } else {
      const { tabs } = this.props;
      transLateW = padding;
      for (let i = 0; i < tabs.length; i++) {
        if (i >= activeKey) break;
        let width = ReactDOM.findDOMNode(this.refs[`link${i}`]).getBoundingClientRect().width;
        transLateW += width + padding * 2;
      }
      transLateW += linkWidth / 2 - lineW / 2;
    }

    line.style.transform = `translateX(${transLateW}px)`;
    line.style.WebkitTransform = `translateX(${transLateW}px)`;
    this.setState({
      activeKey,
    });
    if (isClick) {
      this.props.onTabsChange(ID);
    }
  }
  isView() {
    const { tabs } = this.props;
    let links = ReactDOM.findDOMNode(this.refs.links);
    let linksW = links.getBoundingClientRect().width;
    let pageCount = Math.floor(linksW / baseWidth);
    let lastWidth = linksW % baseWidth;
    this.setState({
      pageCount, lastWidth,
    })
    return tabs.length > 8 && linksW > baseWidth;
  }
  onLeft(curPage) {
    let moveWidth = -baseWidth * curPage;
    this.setState({
      showLeft: true,
      showRight: true,
      cur: curPage,
    })
    if (curPage === 0) {
      moveWidth = 0;
      this.setState({
        showLeft: false,
      })
    }
    this.onMove(moveWidth);
  }
  onRight(curPage) {
    const { pageCount, lastWidth, } = this.state;
    let moveWidth = -baseWidth * curPage;
    this.setState({
      showLeft: true,
      showRight: true,
      cur: curPage,
    })
    if (curPage === pageCount - 1) {
      moveWidth = -baseWidth * (curPage - 1) - lastWidth;
      this.setState({
        showRight: false,
      })
    }
    this.onMove(moveWidth);
  }
  onMove(moveWidth) {
    let links = ReactDOM.findDOMNode(this.refs.links);
    links.style.transform = `translateX(${moveWidth}px)`;
    links.style.WebkitTransform = `translateX(${moveWidth}px)`;
  }

  render() {
    const { tabs } = this.props;
    let { showLeft, showRight, cur } = this.state;
    return (
      <div className="course-tabs">
        {
          showLeft && <p className="left" onClick={() => this.onLeft(--cur)}><MyIcon type="iconwangzuo" /></p>
        }
        <div className="course-tabs-inner">

          <div className="course-tabs-links" ref="links">
            {tabs.map((item, key) => (
              <div
                key={item.ID}
                className={`course-tabs-link ${
                  this.state.activeKey === key ? 'course-tabs-active-link' : ''
                  }`}
                style={{ fontSize, padding: `0 ${padding}` }}
                onClick={this.onTabChange.bind(this, key, item.ID, true)}
              >
                <span data-count={item.count} ref={`link${key}`}>{item.Name}</span>
              </div>
            ))}
            <div className="course-tabs-animation-line" ref="line" style={{ width: lineW }} />
          </div>
        </div>
        {
          showRight && <p className="right" onClick={() => this.onRight(++cur)}><MyIcon type="iconwangyou-" /></p>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/course/Tabs.js